import type { Clinic } from '../../../types'
import type { AustralianState } from '../../../types'
import type { PrescriberLocationProfile } from '../../../types/location'

/** Resolved clinic/location for prescribing — single source for New Script flows */
export type PrescribingLocation = Clinic & {
  isWorkLocation: boolean
  providerNumber?: string
}

export const buildPrescribingLocation = (
  location: PrescriberLocationProfile | undefined | null,
  fallbackClinic: Clinic | undefined
): PrescribingLocation | null => {
  if (!fallbackClinic) return null
  if (!location) {
    return { ...fallbackClinic, isWorkLocation: false }
  }

  return {
    id: location.id,
    name: location.name,
    hpio_number: fallbackClinic.hpio_number,
    hpio_status: fallbackClinic.hpio_status,
    hpio_message: fallbackClinic.hpio_message,
    address_1: location.address1,
    address_2: location.address2 ?? undefined,
    suburb: location.suburb,
    postcode: location.postcode,
    state: location.state as AustralianState,
    email: location.email,
    phone_number: location.phoneNumber,
    isWorkLocation: true,
    providerNumber: location.providerNumber ?? undefined,
  }
}
